module.exports = __webpack_public_path__ + "static/media/agenda3.81ea5a4c.jpg";